import { ErrorType } from "@components/global/new/Error/Error";
import { calculateHash, HashFactorName } from "./hash.utils";

interface Elems extends HTMLFormControlsCollection {
  [key: string]: any; // HTMLInputElement
}
// стараюсь не использвать эту версию, без костылей для mining_persent
export const getFormValue = <T = { [key: string]: string }>(
  elems: Elems
): T => {
  let values: any = {};
  for (let el in elems) {
    const element = elems[el] as HTMLInputElement;
    if (element.id) {
      const dataBage = element.dataset.bage as HashFactorName;
      const value = element.defaultValue || element.value;

      if (element.id === "mining_persent") {
        const v = value.split("=");
        values = {
          ...values,
          [element.id]: v[0],
          ["admin_setting"]: v[1],
        };
        break;
      }
      values = {
        ...values,
        [element.id]: dataBage ? calculateHash(value, dataBage) : value,
      };
    }
  }
  return values;
};

export const getFormValues = <T = { [key: string]: string }>(
  elems: Elems
): T => {
  let values: any = {};
  for (let i = 0; i < elems.length; i++) {
    const element = elems[i];
    if (
      element instanceof HTMLInputElement ||
      element instanceof HTMLSelectElement ||
      element instanceof HTMLTextAreaElement
    ) {
      const elementId = element.id ? element.id : element.name;
      if (elementId) {
        let value;
        if (element instanceof HTMLSelectElement) {
          value = element.value;
        } else {
          value = element.defaultValue || element.value;
        }
        const dataBage = element.dataset?.bage as HashFactorName;
        values = {
          ...values,
          [elementId]: dataBage ? calculateHash(value, dataBage) : value,
        };
      }
    }
  }
  return values;
};

export interface FormRawValues {
  [key: string]: any;
}

export interface FormBadges {
  [key: string]: HashFactorName;
}

export interface FormValues {
  readonly values: FormRawValues;
  readonly badges?: FormBadges;
}

export const getFormValue2 = (elems: Elems): FormValues => {
  const values: FormRawValues = {};
  const badges: FormBadges = {};

  for (let el in elems) {
    const element = elems[el] as HTMLInputElement;
    if (!element.id) {
      continue;
    }

    const dataBage = element.dataset.bage as HashFactorName;
    const value = element.defaultValue || element.value;

    if (value === "") {
      values[element.id] = undefined;
    } else {
      values[element.id] = value;
    }

    if (dataBage) {
      badges[element.id] = dataBage;
    }
  }
  return { values, badges };
};

interface ErrOptions {
  withoutError?: boolean;
  message?: string;
  cb?(err: ErrorType): void;
}

export const isEmptyForm = (
  values: { [key: string]: string },
  errOptions?: ErrOptions
): boolean => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let error: any;
  // if (!errOptions?.withoutError) {
  //   error = useToasts().error;
  // }

  for (let key in values) {
    // Исключаем ключи с "rc_select_" из проверки
    if (key.includes("rc_select_")) {
      continue;
    }
    // Если есть хотя бы одно заполненное поле - форма не пустая
    if (values[key] && values[key].length > 0) {
      return false;
    }
  }

  // Если не найдено ни одного заполненного поля - форма пустая
  if (errOptions?.withoutError) return true;

  if (errOptions?.cb) {
    errOptions?.cb({
      ownError: errOptions.message !== undefined ? [errOptions.message] : [],
    });
    return true;
  }

  error(errOptions?.message || "Fill in all fields");
  return true;
};

export const isEmptyFields = (value: { [key: string]: string }): boolean => {
  for (let key in value) {
    if (
      value[key] !== "" &&
      value[key] !== null &&
      typeof value[key] !== "undefined"
    ) {
      return false;
    }
  }
  return true;
};
